import { Skeleton } from '@kiwicom/orbit-components';
import { useIntl } from 'react-intl';

const RequestsPlaceholder = (): JSX.Element => {
  const intl = useIntl();

  return (
    <div
      style={{
        backgroundColor: '#fff',
        width: '100%',
      }}
    >
      <Skeleton
        width="100%"
        height={300}
        dataTest="RequestsPlaceholder"
        title={intl.formatMessage({
          id: 'common.loading',
          defaultMessage: 'Loading',
        })}
      >
        <rect x="24" rx="4" ry="3" y="20" height="16" width="15%" />
        <rect x="92%" rx="4" ry="3" y="20" height="16" width="40px" />
        <rect x="24" rx="4" ry="3" y="45" height="16" width="80%" />
        <rect x="24" rx="4" ry="3" y="70" height="16" width="18%" />
      </Skeleton>
    </div>
  );
};

export default RequestsPlaceholder;
